import { Directive, ElementRef, Input, inject } from "@angular/core";
import { FeatureService } from "../../services/feature.service";

@Directive({ selector: "[raskIfFeature]" })
export class IfFeatureDirective {
    private readonly elementRef = inject(ElementRef);
    private readonly featureService = inject(FeatureService);

    @Input() set raskIfFeature(val: string) {
        this.featureService.getFeatureActive(val).subscribe(isActive => {
            if (!isActive) {
                this.elementRef.nativeElement.remove();
            }
        });
    }

}
